// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends ApiService {

  detail(slug: string, params?: string): Promise<any> {
    let query = params ? '?attrs=' + params : '';
    let url = `/product/${slug}/detail${query}`;
   return this.get(url).toPromise();
  }

}
